import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import moment from 'moment';

import { gameActions } from '../../../actions';
import {getOrderedGames} from '../../../selectors';
import ReactTable from 'react-table';

class AdminGameList extends React.Component {
    constructor(props){
        super(props);
        this.state = {}
    }

    componentDidMount(){
        this.props.fetchGames();
    }

    render(){
        const columns = [{
            id: 'date',
            Header: 'Date',
            accessor: g => moment(g.gameStartTime).format('dddd, MMMM DD, YYYY'),
            minWidth: 200,
            sortMethod: (a, b) => {
                let dateA = moment(a),
                dateB = moment(b);

                // Compare the dates
                if(dateA.isBefore(dateB)) return -1;
                if(dateA.isAfter(dateB)) return 1;
                return 0;
            }
        }, {
            id: 'time',
            Header: 'Time',
            accessor: g => `${moment(g.gameStartTime).format('h:mm a')} - ${moment(g.gameEndTime).format('h:mm a')}`,
            minWidth: 150,
            sortable: false
        }, {
            Header: 'Arena',
            accessor: 'arena'
        }, {
            id: 'cost',
            Header: 'Credit Cost',
            accessor: g => `${g.playerCost} (Player) / ${g.goalieCost} (Goalie)`,
            minWidth: 150
        }, {
            id: 'playerCount',
            Header: 'Player Count',
            accessor: g => `${g.playerCount}/ ${g.maxPlayers}`
        }, {
            id: 'goalieCount',
            Header: 'Goalies Count',
            accessor: g => `${g.goalieCount}/ ${g.maxGoalies}`
        }, {
            id: 'edit',
            Header: 'Edit Game',
            accessor: g => <Link to={`/admin/edit-game/${g.id}`}>Edit</Link>,
            sortable: false
        }, {
            Header: 'Roster',
            accessor: 'id',
            Cell: row => (
                <span>
                    <Link to={`/admin/game-roster/${row.value}`}>View</Link>
                </span>
            ),
            sortable: false
        }]

        return (
            <div className="mb3">
                <ReactTable
                    data={this.props.games}
                    columns={columns}
                    defaultPageSize={10}
                />
            </div>
        );
    }
}

function mapStateToProps(state){
    return {
        games: getOrderedGames(state)
    }
}
export default connect(mapStateToProps, gameActions)(AdminGameList);


// WEBPACK FOOTER //
// ./src/components/Admin/Games/AdminGameList.js